import {catchNonFatalDefault} from 'io/errors';
import {updateUser, getMcpConnections, deleteMcpConnectionToken} from './io';
import {effect} from 'utils/redux';
import namespace from './namespace';
import services from 'services';
import * as actions from './actions';
import {setPageTitleMessage, decorateWithNotifications} from 'io/app';
import msgs from 'dicts/messages';
import * as commonSelectors from 'modules/common/selectors';
import {userHasPermission} from 'utils/perms';

const creator = effect(namespace);

let intl = null;
services.waitFor('intl').then(x => (intl = x));

export let initialize = () => (getState, dispatch) => {
	setPageTitleMessage('Profile')(getState, dispatch);

	const user = commonSelectors.user(getState());
	if (!userHasPermission(user, 'mcp.allow_mcp_use')) {
		return;
	}

	dispatch(actions._mcpConnectionsLoading());
	getMcpConnections()
		.then(tokens => dispatch(actions._setMcpConnections(tokens || [])))
		.catch(error => {
			dispatch(actions._mcpConnectionsLoadFailed());
			catchNonFatalDefault(getState, dispatch)(error);
		});
};
initialize = creator('initialize', initialize);

export let updateUserData =
	({id, user, needsReload}) =>
	(getState, dispatch) => {
		decorateWithNotifications(
			{
				id: 'update-user',
				failureStyle: 'error',
				loading: intl.formatMessage({id: msgs.processing}),
				success: intl.formatMessage({id: 'Saved'}),
			},
			updateUser(id, user),
		)(getState, dispatch)
			.then(() => {
				if (needsReload) {
					window.location.reload();
				} else {
					dispatch(actions._userUpdated());
				}
			})
			.catch(catchNonFatalDefault(getState, dispatch));
	};
updateUserData = creator('updateUserData', updateUserData);

export let disconnectMcpClientTokens =
	({clientId, tokenIds}) =>
	(getState, dispatch) => {
		dispatch(actions._disconnectMcpClientStarted(clientId));

		const disconnectPromise = Promise.all(
			tokenIds.map(tokenId => deleteMcpConnectionToken(tokenId)),
		).then(() => getMcpConnections());

		decorateWithNotifications(
			{
				id: `disconnect-mcp-client-${clientId}`,
				failureStyle: 'error',
				loading: intl.formatMessage({id: msgs.processing}),
				success: intl.formatMessage({id: 'MCP connection disconnected'}),
			},
			disconnectPromise,
		)(getState, dispatch)
			.then(tokens => {
				dispatch(actions._setMcpConnections(tokens || []));
				dispatch(actions._disconnectMcpClientFinished(clientId));
			})
			.catch(error => {
				dispatch(actions._disconnectMcpClientFinished(clientId));
				catchNonFatalDefault(getState, dispatch)(error);
			});
	};
disconnectMcpClientTokens = creator(
	'disconnectMcpClientTokens',
	disconnectMcpClientTokens,
);
